import React from 'react'
import PropTypes from 'prop-types'
import { useTurbolinksReload } from '../../../shared_components/Hooks'
import ErrorBoundary from '../../Shared/ErrorBoundary'
import SearchResultsMap from '../../Shared/SearchResultsMap'
import { rootStoreInstance } from '../SearchBar/stores'

const StatefulSearchMap = ({
  header,
  collection,
  useHandDrawing = true,
  usePropertyPolygons = true,
  searchParams
}) => {
  useTurbolinksReload({ store: rootStoreInstance, event: 'turbolinks:load' })

  const { listingTypeStore, valueStateStore } = rootStoreInstance

  const handleBoundsChanged = value => {
    valueStateStore.mapBounds = value
  }

  const handleSubmitSearch = () => {
    valueStateStore.mapChangeSubmit(listingTypeStore)
  }

  const handleSearchPolygonChanged = value => {
    valueStateStore.setSearchPolygon(value)
  }

  const onSubmitPolygon = () => {
    valueStateStore.mapPolygonSubmit()
  }

  return (
    <ErrorBoundary>
      <div className='SearchMap'>
        <div className='SearchMap-container'>
          <SearchResultsMap
            showListingCount
            header={header}
            collection={collection}
            mapBounds={valueStateStore.values.mapBounds}
            searchPolygon={valueStateStore.values.searchPolygon}
            onSubmitSearch={handleSubmitSearch}
            onSubmitPolygon={onSubmitPolygon}
            onBoundsChanged={handleBoundsChanged}
            onSearchPolygonChanged={handleSearchPolygonChanged}
            useHandDrawing={useHandDrawing}
            usePropertyPolygons={usePropertyPolygons}
            searchParams={searchParams}
            valueStateStore={valueStateStore}
          />
        </div>
      </div>
    </ErrorBoundary>
  )
}

StatefulSearchMap.propTypes = {
  header: PropTypes.string.isRequired,
  collection: PropTypes.array,
  useHandDrawing: PropTypes.bool,
  usePropertyPolygons: PropTypes.bool,
  searchParams: PropTypes.shape({
    url: PropTypes.string.isRequired,
    query: PropTypes.shape({}).isRequired
  })
}

export default StatefulSearchMap
